/* eslint-disable react/prop-types */
import React, { PureComponent } from 'react';
import { Form, Input, Button, DatePicker, Select, InputNumber } from 'antd';
import { Segment } from '@fxtr/i18n';
import {
  createPhoneBlurHandler,
  getPhoneFieldRules,
  getPhonePlaceholder,
  revalidatePhoneFields,
  HERO_MOBILE_FIELD_NAMES,
} from '$app/shared/utils/phoneValidation';

const { Option } = Select;
const translate = (key, fallback) => fallback;

class HeroesForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      useDistanceBasedPricing: this.props.initialValue ? this.props.initialValue.distanceBasedPricing : false,
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.onSubmit(e, this.props.form);
  };

  handleSegmentChange = (segment) => {
    this.setState({ selectedSegment: segment });
    revalidatePhoneFields(this.props.form, HERO_MOBILE_FIELD_NAMES);
  };

  render() {
    const { zones, loading, form } = this.props;
    const { getFieldDecorator } = form;
    const activeSegment = form.getFieldValue('segment') || this.state.selectedSegment;
    const phonePlaceholder = getPhonePlaceholder(activeSegment, translate);

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
    };

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <Form {...formItemLayout} onSubmit={this.handleSubmit}>
        <Form.Item label="Segment" hasFeedback>
          {getFieldDecorator('segment', {
            rules: [
              {
                required: true,
              },
            ],
          })(
            <Select placeholder="Select a segment" onChange={this.handleSegmentChange}>
              <Option value={Segment.Fixter_UK}>United Kingdom 🇬🇧</Option>
              <Option value={Segment.Fixter_FR}>France 🇫🇷</Option>
            </Select>
          )}
        </Form.Item>
        <Form.Item label="Staff Number" hasFeedback>
          {getFieldDecorator('staffNumber', {
            rules: [
              {
                required: false,
              },
            ],
          })(<Input placeholder="Generated Automatically" disabled />)}
        </Form.Item>
        <Form.Item label="E-mail" hasFeedback>
          {getFieldDecorator('emailAddress', {
            rules: [
              {
                required: true,
                message: 'Please input a valid email',
                type: 'email',
              },
            ],
          })(<Input placeholder="e.g example@email.com" />)}
        </Form.Item>
        <Form.Item
          label="Mobile number"
          hasFeedback
          help="Include country code or use a local mobile number. Values are saved in international format."
        >
          {getFieldDecorator('mobileNumber', {
            rules: getPhoneFieldRules({
              form,
              segment: activeSegment,
              mobileOnly: true,
              required: true,
              requiredMessage: 'Please input a valid mobile number',
              t: translate,
            }),
          })(
            <Input
              type="tel"
              placeholder={phonePlaceholder}
              onBlur={createPhoneBlurHandler({
                form,
                fieldName: 'mobileNumber',
                segment: activeSegment,
                mobileOnly: true,
              })}
            />
          )}
        </Form.Item>
        <Form.Item label="Link to image" hasFeedback>
          {getFieldDecorator('photoUrl', {
            rules: [
              {
                required: false,
              },
            ],
          })(<Input placeholder="e.g https://profile.com/image.png" />)}
        </Form.Item>
        <Form.Item label="Gender" hasFeedback>
          {getFieldDecorator('gender')(
            <Select placeholder="Select a option..." onChange={this.handleSelectChange}>
              <Select.Option value="male">Male</Select.Option>
              <Select.Option value="female">Female</Select.Option>
            </Select>
          )}
        </Form.Item>
        <Form.Item label="Default driver zone" hasFeedback>
          {getFieldDecorator('defaultZoneId', {
            rules: [
              {
                required: true,
              },
            ],
          })(
            <Select placeholder="Select the area covered by the driver" onChange={this.handleSelectChange}>
              <Select.Option disabled value="">
                Select zone
              </Select.Option>
              {zones.map((z) => (
                <Select.Option key={z.ownerId} value={z.ownerId}>
                  {z.name}
                </Select.Option>
              ))}
            </Select>
          )}
        </Form.Item>
        <Form.Item label="Salutation" hasFeedback>
          {getFieldDecorator('salutation', {
            rules: [
              {
                required: false,
              },
            ],
          })(<Input placeholder="Mrs/Ms/Mr" />)}
        </Form.Item>
        <Form.Item label="First Name" hasFeedback>
          {getFieldDecorator('firstName', {
            rules: [
              {
                required: true,
              },
            ],
          })(<Input />)}
        </Form.Item>
        <Form.Item label="Middle Name" hasFeedback>
          {getFieldDecorator('middleName', {
            rules: [
              {
                required: false,
              },
            ],
          })(<Input />)}
        </Form.Item>
        <Form.Item label="Last Name" hasFeedback>
          {getFieldDecorator('lastName', {
            rules: [
              {
                required: true,
              },
            ],
          })(<Input />)}
        </Form.Item>
        <Form.Item label="Date of birth" hasFeedback>
          {getFieldDecorator('dateOfBirth', {
            rules: [
              {
                required: false,
              },
            ],
          })(<DatePicker />)}
        </Form.Item>
        <Form.Item label="National Insurance Number" hasFeedback>
          {getFieldDecorator('niNumber', {
            rules: [
              {
                required: false,
              },
            ],
          })(<Input placeholder="e.g SN 23 23 23 D" />)}
        </Form.Item>
        <Form.Item label="Driving License Categories" hasFeedback>
          {getFieldDecorator('licenseCategories', {
            rules: [
              {
                required: false,
              },
            ],
          })(<Input placeholder="e.g A, B, C, D..." />)}
        </Form.Item>
        <Form.Item label="Driving License Number" hasFeedback>
          {getFieldDecorator('licenseNumber', {
            rules: [
              {
                required: false,
              },
            ],
          })(<Input placeholder="e.g BLAST9910100B99WV 04" />)}
        </Form.Item>
        <Form.Item label="Driving License Issue Date" hasFeedback>
          {getFieldDecorator('issueDate', {
            rules: [
              {
                required: false,
              },
            ],
          })(<DatePicker />)}
        </Form.Item>
        <Form.Item label="Driving License Issue Expiry" hasFeedback>
          {getFieldDecorator('expiryDate', {
            rules: [
              {
                required: false,
              },
            ],
          })(<DatePicker />)}
        </Form.Item>
        <Form.Item label="Status" hasFeedback>
          {getFieldDecorator('status', {
            rules: [
              {
                required: true,
              },
            ],
          })(
            <Select
              placeholder="Select a option and change input text above"
              onChange={this.handleSelectChange}
            >
              <Select.Option value="active">Active</Select.Option>
              <Select.Option value="inactive">Inactive</Select.Option>
            </Select>
          )}
        </Form.Item>
        <Form.Item label="Hero Rate" hasFeedback>
          {getFieldDecorator('defaultRate', {
            rules: [
              {
                required: true,
              },
            ],
          })(<Input placeholder="e.g 20" />)}
        </Form.Item>
        <Form.Item label="Distance Based Pricing">
          {getFieldDecorator('distanceBasedPricing', {
            initialValue: this.state.useDistanceBasedPricing ? 'true' : 'false',
          })(
            <Select onChange={(useDistanceBasedPricing) => this.setState({ useDistanceBasedPricing })}>
              <Option value="true">Enabled</Option>
              <Option value="false">Disabled</Option>
            </Select>
          )}
        </Form.Item>
        {this.props.form.getFieldValue('distanceBasedPricing') === 'true' && (
          <>
            <Form.Item label="0 - 1.5 Miles Rate" hasFeedback>
              {getFieldDecorator('dbpRateTier1', {
                rules: [
                  {
                    required: true,
                  },
                ],
              })(<InputNumber type="number" placeholder="e.g 7" />)}
            </Form.Item>
            <Form.Item label="1.51 - 3 Miles Rate" hasFeedback>
              {getFieldDecorator('dbpRateTier2', {
                rules: [
                  {
                    required: true,
                  },
                ],
              })(<InputNumber type="number" placeholder="e.g 10" />)}
            </Form.Item>
            <Form.Item label="3.1 Miles + Rate" hasFeedback>
              {getFieldDecorator('dbpRateTier3', {
                rules: [
                  {
                    required: true,
                  },
                ],
              })(<InputNumber type="number" placeholder="e.g 12" />)}
            </Form.Item>
          </>
        )}
        <Form.Item label="Xero ID" hasFeedback>
          {getFieldDecorator('xeroId', {
            rules: [
              {
                required: false,
              },
            ],
          })(<Input placeholder="Will be generated Automatically" disabled />)}
        </Form.Item>
        <Form.Item label="Kit Size" hasFeedback>
          {getFieldDecorator('kitSize', {
            rules: [
              {
                required: false
              },
            ],
          })(<Input placeholder="e.g L"/>)}
        </Form.Item>
        <Form.Item label="Kit Delivery Status" hasFeedback>
          {getFieldDecorator('kitDeliveryStatus', {
            rules: [
              {
                required: false
              },
            ],
          })(<Input placeholder="e.g Delivered" />)}
        </Form.Item>
        <Form.Item label="Driver Start Date" hasFeedback>
          {getFieldDecorator('driverStartDate', {
            rules: [
              {
                required: false
              },
            ],
          })(<DatePicker />)}
        </Form.Item>
        <Form.Item label="Driver End Date" hasFeedback>
          {getFieldDecorator('driverEndDate', {
            rules: [
              {
                required: false
              },
            ],
          })(<DatePicker />)}
        </Form.Item>
        <Form.Item label="Account Number / IBAN" hasFeedback>
          {getFieldDecorator('bankNumber', {
            rules: [
              {
                required: true,
                message: 'Please input a valid Account Number(UK) / IBAN(FR)',
              },
            ],
          })(<Input placeholder="e.g 10083724 / FR17 3250 0086 7796 7411" />)}
        </Form.Item>
        <Form.Item label="Sort Code / BIC" hasFeedback>
          {getFieldDecorator('bankCode', {
            rules: [
              {
                required: true,
                message: 'Please input a valid Sort Code(UK) / BIC(FR)',
              },
            ],
          })(<Input placeholder="e.g 05-00-75 / BEVOLT21" />)}
        </Form.Item>
        <Form.Item {...tailFormItemLayout}>
          <Button type="primary" htmlType="submit" loading={loading}>
            Save
          </Button>
        </Form.Item>
      </Form>
    );
  }
}

export default (mapPropsToFields) => Form.create({ name: 'hero-editor', mapPropsToFields })(HeroesForm);
